import "core-js/modules/es.array.push.js";
import { Dialog, DialogPanel, DialogTitle, TransitionRoot, TransitionChild } from "@headlessui/vue";
import pkg from "@/../package.json"; // 确保路径正确
import { ref, reactive } from 'vue';
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css"; // 🔥 这里引入样式
import RadioSatisfyQuestionnaire from "@/components/RadioSatisfyQuestionnaire.vue";
import Message from "@/components/message";
import service from "@/service";
export default {
  name: "QuestionnaireDialog",
  components: {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionRoot,
    TransitionChild,
    Multiselect,
    RadioSatisfyQuestionnaire
  },
  // setup(){
  //     const userResults = reactive({values:[]})
  // },
  data: () => ({
    showQuestionnaire: false,
    data: [],
    userResults: [],
    isLoading: false
  }),
  created() {
    this.userResults = reactive([]);
  },
  methods: {
    // stop(e){
    //     console.log("steop", e)
    //     e.stopPropagation()
    //     e.preventDefault()
    // },
    handleHashChange() {
      if (this.$route.hash === '#questionnaire') {
        this.showQuestionnaire = true;
      }
    },
    async closeDialog(e) {
      const results = Array.from(this.userResults);
      const results2 = results.map(item => {
        if (item instanceof Array) {
          return item.map(subitem => subitem?.value || subitem);
        } else {
          return item;
        }
      });
      const sendData = JSON.parse(JSON.stringify(this.data.reduce((preV, curV, i) => ({
        ...preV,
        [i]: results2[i]
      }), {})));

      // console.log('send data', sendData, JSON.stringify(results))
      try {
        const res = await service({
          url: "/api/create_questionnaire_answer",
          method: "post",
          data: {
            questionnaire_id: this.questionnaire_id,
            data: sendData,
            version: this.questionnaire_id
          }
          // headers: {
          // "Content-Type": "multipart/form-data",
          // },
        });
      } catch (error) {
        console.error(error);
        Message.text(error);
      }
      Message.text(this.$t("Questionnaire.thx"));
      this.userResults = [];
      this.$router.push("");
    },
    updateFormValue(questionIndex, optionIndex) {
      this.userResults[questionIndex] = optionIndex;
    }
  },
  watch: {
    "$route.hash"(newHash) {
      if (newHash === "#questionnaire") {
        this.showQuestionnaire = true;
      } else {
        this.showQuestionnaire = false;
      }
    },
    async showQuestionnaire(nV) {
      if (nV === true) {
        if (this.data.length == 0) {
          // const fn = 
          this.isLoading = true;
          try {
            const tmp = await import(`@/assets/questionnaire/${this.questionnaire_id}.json`);
            this.isLoading = false;
            this.data = ref(tmp.default.questions);
          } catch (e) {
            this.isLoading = false;
            console.log('request wrong');
          }
        }
      }
    }
  },
  computed: {
    disableSubmit() {
      const tmp = this.data.map((item, i) => {
        if (item.required && (this.userResults[i] == undefined || this.userResults[i] === null || this.userResults[i] instanceof Array && this.userResults[i].length == 0)) {
          return false;
        } else {
          return true;
        }
      });
      // console.log("can submit", tmp, tmp.includes(false))
      if (tmp.includes(false)) {
        // console.log("cannot submit")
        return true;
      } else {
        return false;
      }
    },
    questionnaire_id() {
      return `${this.$i18n.locale === "zh" ? 'zh' : 'en'}_${pkg.questionnaireVersion}`;
    }
  },
  mounted() {
    // console.log(123, "questionnaire", require.context("@/assets/questionnaire", false, /\.json$/).keys())
    this.handleHashChange();
  }
};